// import { decode } from 'js-base64'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { RouterName } from '@/enums/router-name'
import type { LoginResponse } from '@/models/api/login-response'
import { useAuthStore } from '@/stores/use-auth-store'
import { useUserProfileStore } from '@/stores/use-user-profile-store'

export function ssoRedirectGuard(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): void {
  const authStore = useAuthStore()
  const userStore = useUserProfileStore()
  const data = to.query as unknown as LoginResponse

  const { redirect, token, email, name, uid, lang, error } = data

  if (error) {
    next({ name: RouterName.ERROR, query: { error } })
    return
  }

  authStore.setTokenData(token)
  authStore.setLang(lang)
  userStore.setUserInfo({
    name,
    token,
    email,
    uid,
    lang
  })

  if (redirect) {
    const BASE_URL =
      import.meta.env.VITE_API_PROXY_URL + import.meta.env.VITE_CONFIG_BASE
    const path = redirect.split(BASE_URL, 2)[1]
    next({ path })
  } else {
    next({ name: RouterName.HOME })
  }
}
